// extracted by mini-css-extract-plugin
module.exports = {"root":"DependentItem_root__2C1nJ","body":"DependentItem_body__1QbHw"};